module.exports = __webpack_public_path__ + "img/pro011.7f95711f.jpg";